import { IModel, IModelResponse } from '../types/model';

export type TDefaultConfigFunc = (dealType: string, offerType: string) => TNotesModel;

export const defaultConfig: TDefaultConfigFunc = (dealType: string, offerType: string) => ({
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolithPython',
  pathApi: `/ajax/${dealType}/${offerType}/notes/`,
});

export interface ICreateNotesModelParams {
  dealType: string;
  offerType: string;
  config: Partial<TNotesModel>;
}
export function createNotesModel({ config, dealType, offerType }: ICreateNotesModelParams): TNotesModel {
  return { ...defaultConfig(dealType, offerType), ...config };
}

export type TNotesModel = IModel<INotesRequestScheme, TNotesResponseScheme>;
export type TNoteAction = 'save' | 'delete';

export interface INotesRequestScheme {
  text: string | undefined;
  action: TNoteAction;
  oid: string;
  csrf_token: string;
}

export type TNotesResponseScheme = INotesResponse200 | INotesResponse400;

export interface INotesResponse200 extends IModelResponse<INotesResponseScheme> {
  statusCode: 200;
}

export interface INotesResponseScheme {
  status: 'ok';
}

export interface INotesResponse400 extends IModelResponse<INotesErrorResponseScheme> {
  statusCode: 400;
}

export interface INotesErrorResponseScheme {
  // свагера на апишку нет, и формат ошибки непонятен
  // oxlint-disable-next-line typescript/no-explicit-any
  errors: any[];
  message: string;
}
